import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'

type Props = {
    length: number,
    password?: boolean,
    disabled?: boolean,
    modelValue: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'code-input',
  props: {
    length: null,
    password: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({(e: 'update:modelValue', modelValue: string): void}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    length: number,
    password?: boolean,
    disabled?: boolean,
    modelValue: string
}




const code = ref("")
const inputs = ref<HTMLInputElement[]>([])

onMounted(() => {
    if (props.modelValue?.length > 0) {
        for (let i = 0; i < props.length && i < props.modelValue.length; i++) {
            inputs.value[i].value = props.modelValue[i]
        }
    }
})

const onFocus = (index: number) => {
    // If everything to the right of it is empty and there are open spaces to the left, we shouldn't let them enter it
    let rightIsClear = true
    for (let i = index; i < props.length; i++) {
        let input = inputs.value[i]
        if (input.value.length) {
            rightIsClear = false
            break;
        }
    }
    if (rightIsClear && inputs.value?.[index - 1] && !inputs.value[index - 1].value.length) {
        inputs.value[index - 1].focus()
    }
}

const handleKeydown = (event: KeyboardEvent, index: number) => {
    let input = inputs.value[index]
    let key = event.key
    if (key == "Backspace") {
        if (!input.value) {
            if (inputs.value?.[index - 1]) {
                inputs.value[index - 1].focus()
            }
        } else {
            input.value = ''
            //Maybe move down the input here?
        }
    } else if (key == "ArrowLeft") {
        if (inputs.value?.[index - 1]) {
            inputs.value[index - 1].focus()
        }
    } else if (key == "ArrowRight") {
        if (inputs.value?.[index + 1]) {
            inputs.value[index + 1].focus()
        }
    }
    updateCode()
}

const handleInput = (event: InputEvent, index: number) => {
    let input = inputs.value[index]
    let key = event.data
    if(key){
        if (key.length == 1 || (key.length > 1 && /[^0-9]/.test(key))) {
            input.value = key

            if (inputs.value?.[index + 1]) {
                inputs.value[index + 1].focus()
            } else {
                input.blur()
            }
            updateCode()
        }
    }
}

const updateCode = () => {
    let tmpCode = ""
    for (let singleInput of inputs.value) {
        if (singleInput.value)
            tmpCode += singleInput.value
    }
    code.value = tmpCode

    emit('update:modelValue', code.value)
}

const handlePaste = (event: ClipboardEvent, index: number) => {
    let pastedText = (event.clipboardData || (window as any).clipboardData).getData('text')
    if (!pastedText.length) return
    if (pastedText.length >= 5) {
        pastedText = pastedText.substring(0, 5)
    }

    for (let i = 0; i < props.length - index && i < pastedText.length; i++) {
        let currentInput = inputs.value[i + index]
        currentInput.value = pastedText[i]
    }

    updateCode()
}

const __returned__ = { props, emit, code, inputs, onFocus, handleKeydown, handleInput, updateCode, handlePaste, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})